var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDivide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#262626",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.75h20v1.5H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 1.25,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15.75,
    r: 1.25
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMCAxNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9IiMyNjI2MjYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgNy43NWgyMHYxLjVIMHoiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEuMjUiIHI9IjEuMjUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjE1Ljc1IiByPSIxLjI1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconDivide as ReactComponent };